import axios from 'axios';
import moment from 'moment';

const merchantToken = 'E4F1B6C1-B61A-4C0A-9DE2-06B740A47C1E';

const karmaKoinAPI = axios.create({});

karmaKoinAPI.interceptors.response.use(
    (response) => {
        if ([0, 200].includes(response.data.Response.ResponseCode)) {
            return response;
        } else {
            return Promise.reject(response);
        }
    },
    (error) => Promise.reject(error)
);

function fetchBalance(pin, token, version) {
    return karmaKoinAPI
        .get(
            `/v2/2/${merchantToken}/card/check/${pin}?captchaToken=${token}&captchaVersion=${version}&format=json`,
            {
                headers: {
                    'Cache-Control': 'no-cache',
                    Pragma: 'no-cache',
                    Expires: -1,
                },
            }
        )
        .then((response) => ({
            amount: response.data.Response.Card.BalanceAmount,
            currency: response.data.Response.Card.Currency,
        }));
}

function combineCards(pin1, pin2, token, version) {
    return karmaKoinAPI
        .post(
            `/v2/2/${merchantToken}/transaction/transfer?captchaToken=${token}&captchaVersion=${version}&format=json`,
            {
                Request: {
                    Merchant: {
                        MerchantName: 'Karmakoin',
                        MerchantDatetime: moment().format(
                            'YYYY-MM-DD HH:mm:ss'
                        ),
                        MerchantTxCode: Math.random()
                            .toString()
                            .substr(2),
                    },
                    Card: {
                        Pin: pin1,
                        ToPin: pin2,
                    },
                    Payer: {},
                },
            }
        )
        .then((response) => response.data.Response.Card.BalanceAmount);
}

export default { fetchBalance, combineCards };
